<template>
  <v-container :fluid="isFluid">
    <!-- <v-row>
      <v-col>
        <div class="d-flex">
          <slot name="action">
            <v-btn text @click="$emit('reload')">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
            <v-btn icon color="primary" v-if="enableCreate" @click="$emit('create')">
              <v-icon>mdi-plus-thick</v-icon>
            </v-btn>
          </slot>
        </div>
      </v-col>
    </v-row> -->
    <slot name="listHeader">
      <v-row class="mb-1">
        <v-col cols="auto" v-if="$scopedSlots.filterLeft">
          <slot name="filterLeft"></slot>
        </v-col>
        <v-col class="d-flex align-center" style="gap: 10px">
          <h2>{{ title }}</h2>
          <slot name="searchBox" :ctx="this">
            <fletrix-text-field
              icon="mdi-magnify"
              v-model="searchVal"
              background-color="white"
              solo
              :placeholder="searchBoxPlaceholder"
            />
          </slot>
        </v-col>
        <v-col cols="auto" v-if="$scopedSlots.filterRight">
          <slot name="filterRight"></slot>
        </v-col>
        <v-col cols="auto" v-if="enableCreate">
          <v-btn :class="newButtonClass" elevation="0" @click="$emit('create')">
            <v-icon size="32">mdi-plus</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto" v-if="enableReload">
          <v-btn :class="newButtonClass" elevation="0" @click="$emit('reload')">
            <v-icon size="32">mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </slot>
    <div class="custom-container-box">
      <slot name="btn"> </slot>
      <slot name="filter"></slot>
      <!--    <v-row v-if="$vuetify.breakpoint.mobile">-->
      <!--      <v-col :cols="cols" :key="x._id" v-for="x in data.docs">-->
      <!--        <slot name="card" :cardContent="x"></slot>-->
      <!--      </v-col>-->
      <!--    </v-row>-->
      <v-data-table
        class="datatable mb-2"
        :items="data.docs"
        :server-items-length="data.pages || 1"
        :items-per-page="limit || 10"
        :disable-sort="disableSort"
        hide-default-footer
        :headers="header"
        :calculate-widths="isFluid"
        v-bind="$attrs"
        v-on="$listeners"
        @click:row="x => $emit('navDetails', x)"
        :options.sync="options"
        :hide-default-header="true"
      >
        <template v-slot:header="{ isMobile, props, on }">
          <thead v-if="!hideDefaultHeader && !isMobile">
            <tr>
              <th v-for="item in props.headers" :key="item.value">
                <div v-if="item.value === 'data-table-select'">
                  <v-simple-checkbox
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>
                </div>
                <div
                  v-else
                  class="d-flex align-center"
                  :class="{
                    'justify-center': item.align === 'center',
                    'justify-end': item.align === 'right',
                  }"
                >
                  <slot :name="`header.${item.value}`">{{ item.text }}</slot>
                  <span
                    style="cursor: pointer"
                    @click="
                      !disableSort && (item.sortable || item.sortable === undefined)
                        ? on.sort(item.value)
                        : ''
                    "
                    class="ml-1 d-flex flex-column align-center"
                    v-if="!disableSort && (item.sortable || item.sortable === undefined)"
                  >
                    <v-icon color="primary" size="0.55em">
                      {{ getSortIcon(true, item.value) }}</v-icon
                    >
                    <v-icon color="primary" size="0.55em" style="transform: rotate(60deg)">
                      {{ getSortIcon(false, item.value) }}</v-icon
                    >
                  </span>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template v-slot:item.time="{ item }">
          {{ item.time | datetimeRange }}
        </template>
        <template v-slot:item.status="{ item }">
          <div :style="{ color: getColor(item.status) }" label>
            {{ item.status | status }}
          </div>
        </template>
        <template v-for="(_, name) in $scopedSlots" v-slot:[name]="props">
          <slot :name="name" v-bind="props" />
        </template>
      </v-data-table>
      <slot
        name="itemsDisplaySummary"
        v-if="showSummary"
        :itemsDisplaySummary="itemsDisplaySummary"
      >
        <div class="text-center">
          <span v-show="itemsDisplaySummary.total"
            >Item
            <span class="text-body-1 primary--text"
              >{{ itemsDisplaySummary.start | toThousandFilter }} -
              {{ itemsDisplaySummary.end | toThousandFilter }}</span
            >,</span
          >Total
          <span class="text-body-1 primary--text">
            {{ itemsDisplaySummary.total | toThousandFilter }}
          </span>
          Items
        </div>
      </slot>
      <slot name="pagination-top"></slot>
      <v-container class="d-flex align-center justify-center">
        <v-row dense>
          <v-col cols="3">
            <slot name="pagination-left" />
          </v-col>
          <v-col class="auto">
            <v-pagination
              v-if="pagination"
              v-model="pageVal"
              :length="data.pages || 1"
              :total-visible="10"
              :color="paginationColor"
            />
          </v-col>
          <v-col cols="3">
            <slot name="pagination-right" />
          </v-col>
        </v-row>
      </v-container>
      <slot></slot>
    </div>
  </v-container>
</template>

<script>
import { FletrixTextField } from '@/components/Atom';
import { toThousandFilter } from '@/services/filters';
export default {
  components: { FletrixTextField },
  name: 'ListView',
  props: {
    title: {},
    search: {},
    page: {},
    sort: {},
    limit: { default: 10 },
    data: { default: () => ({}) },
    enableCreate: { default: true },
    populate: {},
    cols: { type: Number, default: 12 },
    header: {
      default: () => [{ text: 'ID', value: '_id' }],
    },
    isFluid: { default: false },
    pagination: { type: Boolean, default: true },
    paginationColor: {
      type: String,
      default: 'primary',
    },
    newButtonClass: {
      type: String,
      default: 'icon-button primary',
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    hideDefaultHeader: {
      type: Boolean,
      default: false,
    },
    searchBoxPlaceholder: { type: String, default: '' },
    enableReload: { type: Boolean, default: false },
  },
  emits: ['create', 'reload', 'navDetails'],
  data() {
    return {
      options: {},
      defaultSort: this.sort,
    };
  },
  computed: {
    disableSort() {
      return !this.$listeners['update:sort'];
    },
    searchVal: {
      get() {
        return this.search;
      },
      set(val) {
        this.$emit('update:search', val);
      },
    },
    pageVal: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit('update:page', val);
      },
    },
    sortVal: {
      get() {
        return this.sort;
      },
      set(val) {
        this.$emit('update:sort', val);
      },
    },
    itemsDisplaySummary() {
      return {
        start: this.data.offset + 1,
        end: this.data.offset + this.data.docs.length,
        total: this.data.total,
      };
    },
  },
  watch: {
    options(newValue) {
      const { sortBy, sortDesc } = newValue;
      if (!this.disableSort) {
        if (sortBy.length > 0) {
          const sort = { [sortBy]: sortDesc[0] ? -1 : 1 };
          this.sortVal = Object.assign(sort, this.defaultSort);
        } else {
          this.sortVal = this.defaultSort;
        }
      }
    },
  },
  methods: {
    getColor(status) {
      if (status === '97$cancelled' || status === '98$absent') return 'red';
      // else return 'green'
    },
    getSortIcon(isDesc, value) {
      if (this.sort[value] === 1 && !isDesc) {
        return 'mdi-triangle';
      } else if (this.sort[value] === -1 && isDesc) {
        return 'mdi-triangle';
      }
      return 'mdi-triangle-outline';
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 0.875rem;
  font-weight: 700;
  border-bottom: thin solid rgba(0, 0, 0, 0.32) !important;
}
</style>
